
import { defineComponent, PropType, toRef } from 'vue';
import { useVModel } from 'vue-composable';
import { Client } from '@/types/app';
import { useStore } from '@/store';
import { formDefaults } from '@/constants';
import { addOrEditHeader, useAddEditFormState } from '@/utils';
import AppModal from '@/components/modal/base/AppModal.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import TelInput from '@/components/form-controls/base/TelInput.vue';
import EmailInput from '@/components/form-controls/base/EmailInput.vue';
import CheckboxInput from '@/components/form-controls/base/CheckboxInput.vue';
import { cloneDeep } from 'lodash';

export default defineComponent({
  name: 'ClientAddEditFormModal',
  emits: ['update:openState', 'submit'],
  components: {
    AppModal,
    TextInput,
    TelInput,
    EmailInput,
    CheckboxInput
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    client: {
      type: Object as PropType<Client>
    }
  },
  setup(props, { emit }) {
    const isOpen = useVModel(props, 'openState');
    const header = addOrEditHeader(toRef(props, 'client'));

    const store = useStore();
    const clientState = useAddEditFormState(
      toRef(props, 'client'),
      formDefaults.client,
      store.dispatch.clients.update,
      store.dispatch.clients.create
    );

    const updateTax = (value: boolean) => {
      clientState.value.taxExempt = value;
    };

    const submit = () => emit('submit', cloneDeep(clientState.value));
    return {
      isOpen,
      header,
      clientState,
      submit,
      updateTax
    };
  }
});
